module.exports = __webpack_public_path__ + "static/img/empty-team-icon.797d834e.svg";